import { useLocation } from '@gatsbyjs/reach-router';
import React, { useEffect } from 'react';

import PageLoader from '@components/PageLoader';

import { getQueryParams } from '@utils/url';

const TERRA_DEXCOM_URL = 'https://api.tryterra.co/v2/auth/dexcom/oauth2';

export default function DexcomPage() {
  const location = useLocation();

  useEffect(() => {
    function handleDexcomConnection() {
      const { code, state } = getQueryParams();
      if (typeof state === 'string' && typeof code === 'string') {
        location.replace(
          `${TERRA_DEXCOM_URL}?code=${encodeURIComponent(
            code
          )}&state=${encodeURIComponent(state)}`
        );
      }
    }
    handleDexcomConnection();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return <PageLoader />;
}
